module.exports = __webpack_public_path__ + "static/media/messy-laptop-light.945fbf07.png";